import Header from './components/Header';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import BrandIntro from './components/BrandIntro';
import Collections from './components/Collections';
import ProductShowcase from './components/ProductShowcase';
import PriceGuide from './components/PriceGuide';
import MarketStory from './components/MarketStory';
import Gallery from './components/Gallery';
import Heritage from './components/Heritage';
import Occasions from './components/Occasions';
import Menswear from './components/Menswear';
import WhySrm from './components/WhySrm';
import ContactCta from './components/ContactCta';
import Location from './components/Location';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <BrandIntro />
        <Collections />
        <ProductShowcase />
        <PriceGuide />
        <MarketStory />
        <Gallery />
        <Heritage />
        <Occasions />
        <Menswear />
        <WhySrm />
        <ContactCta />
        <Location />
      </main>
      <Footer />
    </div>
  );
}